module.exports = __webpack_public_path__ + "img/1481777086.dc67e9e4.jpg";